var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_62",
    "data-name": "\\uADF8\\uB8F9 62",
    transform: "translate(-161 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_14",
    "data-name": "\\uD328\\uC2A4 14",
    d: "M164,11449l16-20.115L196.184,11449Z",
    transform: "translate(0 -11174)",
    fill: "#ffe7a5",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    id: "\\uD0C0\\uC6D0_6",
    "data-name": "\\uD0C0\\uC6D0 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(161 272)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    id: "\\uD0C0\\uC6D0_7",
    "data-name": "\\uD0C0\\uC6D0 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(193 272)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    id: "\\uD0C0\\uC6D0_8",
    "data-name": "\\uD0C0\\uC6D0 8",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(177 252)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment);
export default __webpack_public_path__ + "static/media/segment.0f5334c644f2d48890c631535860d7ff.svg";
export { ForwardRef as ReactComponent };